/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { getMembershipDetails } from '../../apis/membership';
import { getParams } from '../../utils/params';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import { comma } from '../../utils/number';
import { isEmpty } from '../../utils/lodashExtend';
import ToolTip from '../ToolTip/ToolTip';
import { COMPANY_STATE } from '../../constants/COMPANY';
import { findIndex } from 'lodash';

const MembershipTaxDetails = () => {

  const [fields, setFields] = useState([]);
  const [filters] = useState([
    {
      title: "세무회사 검색",
      type: "input",
      placeholder: "세무회사 입력",
      key: "search.name",
    },

  ]);
  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm({
    limit: 10,
    offset: 0,
    order: []
    // order: [{ createdTime: 'desc' }]
  });

  const [sortFields, setSortFields] = useState([
    { key: 'taxpayerCnt', order: '' }, // 수임처 개수
    { key: 'allCareCompanies', order: '' }, // 담당 회사 수
    // { key: 'careCompanies', order: '' }, // 담당자 매칭된 회사 수
    // { key: 'careCompanies', order: '' }, // 미지정
    // { key: 'pay', order: '' }, // 유료
    // { key: 'free', order: '' }, // 무료
    { key: 'state', order: '' }, // 승인상태
    { key: 'createdTime', order: 'desc' }, // 가입일
  ]);
  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };


  const submit = (form) => {

    if (form.search?.level === "all") delete form.search.level;
    if (form.search?.targetType === "all") delete form.search.targetType;
    setIsLoading(true);
    getMembershipDetails(getParams(form))
      .then(res => {
        const { list = [], count = 0 } = res;
        setTotal(count);
        setList(list);
      }).finally(() => setIsLoading(false));
  };

  useEffect(() => {

    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }

    console.log('sortFields : ', sortFields)
    console.log('sortField : ', sortField)

  }, [sortFields]);

  useEffect(() => {
    const membershipFields = [];

    list.forEach(item => {
      for (const membership of item.memberships) {
        if (!membershipFields.find(f => f.idx === membership.idx)) {
          membershipFields.push({
            title: membership.label,
            idx: membership.idx,
            // key: 'memberships',
            key: membership.level,
            onValue: (v, length, data) => {
              const _membership = data.memberships.find(f => f.idx === membership.idx);
              return `${comma(_membership.companies?.length || 0)}개`;
            },
            // sort: (key) => handleSort(key), order: (key) => orderKey(key)
          });
        }
      }
    });

    const _fields = [
      {
        title: "세무회사명",
        key: "name",
      },
      {
        title: "대표자명",
        key: "ceoName",
      },
      {
        title: "수임처 개수",
        key: "taxpayerCnt",
        onValue: (v) => `${comma(v || 0)}개`,
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "담당 회사 수", label: "-", key: "allCareCompanies", onValue: (value) => {

          return (
            <>
              {comma(value.length)}개
              {!isEmpty(value) && (
                <ToolTip
                  tooltiptext={value
                    .map(
                      (c) => `${c.name} (${c.comNum} / ${COMPANY_STATE.find(s => s.value === c.state).label})`
                    )
                    .join("\n\n")}
                  position="bottom"
                ></ToolTip>
              )}
            </>
          );
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "담당자 매칭된 담당회사", label: "-", key: "careCompanies", onValue: (value) => {

          return (
            <>
              {comma(value.length)}개
              {!isEmpty(value) && (
                <ToolTip
                  tooltiptext={value
                    .map(
                      (c) => `${c.name} (${c.comNum} / ${COMPANY_STATE.find(s => s.value === c.state).label})`
                    )
                    .join("\n\n")}
                  position="bottom"
                ></ToolTip>
              )}
            </>
          );
        }
      },
      ...membershipFields,
      {
        title: "미지정",
        key: "careCompanies",
        onValue: (value) => {
          const companies = value?.filter(item => isEmpty(item.companyMembership));
          return (
            <>
              {comma(companies.length)}개
              {!isEmpty(companies) && (
                <ToolTip
                  tooltiptext={companies
                    .map(
                      (c) => `${c.name} (${c.comNum} / ${COMPANY_STATE.find(s => s.value === c.state).label})`
                    )
                    .join("\n\n")}
                  position="bottom"
                ></ToolTip>
              )}
            </>
          );
        },
        tooltip: {
          tooltiptext: "멤버십 미지정 회사 목록입니다.",
          position: "bottom"
        },
        // sort: (key) => handleSort(key), order: (key) => orderKey(key)

      },
      {
        title: "승인 상태",
        label: "-",
        key: "state",
        onTranslator: { list: COMPANY_STATE },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: '가입일',
        key: 'createdTime',
        type: 'dateTime',
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
    ];
    setFields(_fields);
  }, [list]);


  useEffect(() => {
    // submit(form);
    setSubmit(submit);
  }, []);


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />

      <ControlTable
        isHideControlHeader
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={false}
        selectedList={selectedList}
        setSelected={setSelectedList}
      />
    </>
  );
};

export default MembershipTaxDetails;